import intlTelInput from "intl-tel-input";

import { Country } from "@/data/model/Enums";

import { TastierClient } from "@/app/TastierClient";
import { trans } from "@/app/localization/Trans";

export class PhoneNumberInput {
    private $element: JQuery;
    private $input: JQuery;

    private plugin: intlTelInput.Plugin;

    constructor(intent?: boolean, value?: string) {
        this.$element = $('<div class="phonenumberinput formcontrol' + (intent === true ? " intent" : "") + '" />');
        this.$element.append("<label>" + trans.signup.phoneNumber + "</label>");
        this.$input = $('<input type="tel" value="' + (value !== undefined ? value : "") + '" />').appendTo(
            this.$element
        );
       
        let initialCountry = "ch";
        if (TastierClient.context.currentAllocation !== undefined) {
            switch (TastierClient.context.currentAllocation.country) {
                case Country.Germany:
                    initialCountry = "de";
                    break;
                case Country.Italy:
                    initialCountry = "it";
                    break;
                case Country.France:
                    initialCountry = "fr";
                    break;
                case Country.Switzerland:
                    initialCountry = "ch";
                    break;
                case Country.Austria:
                    initialCountry = "at";
                    break;
                case Country.Netherlands:
                    initialCountry = "nl";
                    break;
            }
        }

        this.plugin = intlTelInput(this.$input[0], {
            preferredCountries: ["ch", "de", "fr", "it", "at", "nl"],
            initialCountry: initialCountry,
            allowDropdown: true,
            autoPlaceholder: "aggressive",
            nationalMode: true,
            separateDialCode: true,
            utilsScript: "./assets/scripts/libs/intl-tel-input-utils.js",
        });
    }

    public setLabel(l: string): PhoneNumberInput {
        this.$element.find("> label").html(l);
        return this;
    }

    public isValid(): boolean {
        return this.plugin.isValidNumber();
    }

    public getNumber(): string | undefined {
        const nr = this.plugin.getNumber();
        if (nr.length === 0) return undefined;

        return nr;
    }

    public getCountryCode(): string | undefined {
        const ext = this.plugin.getSelectedCountryData();
        if (ext === undefined) return undefined;

        return ext.dialCode;
    }

    public setValue(number?: string): PhoneNumberInput {
        this.plugin.setNumber(number === undefined ? "" : number);
        return this;
    }

    public destroy() {
        this.plugin.destroy();
    }

    public setError(hasError: boolean): PhoneNumberInput {
        if (hasError) this.$element.addClass("has-error");
        else this.$element.removeClass("has-error");

        return this;
    }

    public appendTo($element: JQuery): PhoneNumberInput {
        this.$element.appendTo($element);
        return this;
    }
}
